export const COMMON_MSG = {
  Processing: "Processing...",
  NoDataFound: "No data found.",
  NoDataFoundForDate: "No data found for the selected date.",
  ComboAlreadyExists: "This combination already exists",
  SomethingWentWrong: "Something went wrong. Please try again.",
  Error: "An error occurred. Please try again.",
};

export const DELETE_TITLE = "Delete Record";
export const DELETE_CONTENT = "Are you sure you want to delete this record?";
